/**
 * Renders a progressbar
 * @component lyte-progressbar
 * @version 1.0.0
 */
Lyte.Component.register('lyte-progressbar', {
	data: function () {
		return {
			// ltPropValue : Lyte.attr("string",{"default":'0'}),

			/**
						 * @componentProperty {string} ltPropType
						 * @version 1.0.0
						 * @default bar
						 * @options bar,circle,stacked,vertical
						 */
			ltPropType: Lyte.attr("string", { "default": 'bar' }),	//circle,vertical,stacked,bar

			/**
						 * @componentProperty {colorString} ltPropProgressFillColor
						 * @version 1.0.0
						 * @default #42a2eb
						 */
			ltPropProgressFillColor: Lyte.attr("string", { "default": '#42a2eb' }),

			/**
						 * @componentProperty {colorString} ltPropCompletedFillColor
						 * @version 1.0.0
						 * @default #3fbd5f
						 */
			ltPropCompletedFillColor: Lyte.attr("string", { "default": '#3fbd5f' }),

			/**
						 * @componentProperty {string} ltPropWidth
						 * @version 1.0.0
						 * @default 100%
						 * @suffix px,pt,cm,mm,vh,vm,em,%
						 */
			ltPropWidth: Lyte.attr("string"/*,{"default":'100%'}*/),

			/**
						 * @componentProperty {string} ltPropHeight
						 * @version 1.0.0
						 * @default 12px
						 * @suffix px,pt,cm,mm,vh,vm,em
						 */
			ltPropHeight: Lyte.attr("string"/*,{"default":'12px'}*/),

			/**
						 * @componentProperty {string} ltPropRadius
						 * @version 1.0.0
						 * @default 50
						 */
			ltPropRadius: Lyte.attr("string", { "default": '50' }),

			/**
						 * @componentProperty {string} ltPropStroke
						 * @version 1.0.0
						 * @default 5
						 */
			ltPropStroke: Lyte.attr("string", { "default": '5' }),

			/**
						 * @experimental ltPropValueCopy
						 */
			ltPropValueCopy: Lyte.attr("string", { "default": '0' }),

			/**
						 * @componentProperty {boolean} ltPropAnimated
						 * @version 1.0.0
						 * @default true
						 * 
						 */
			ltPropAnimated: Lyte.attr("boolean", { "default": true }),

			/**
						 * @componentProperty {boolean} ltPropShowPercentage
						 * @version 1.0.0
						 * @default true
						 * 
						 */
			ltPropShowPercentage: Lyte.attr("boolean", { "default": true }),
			/**
			 * @typedef {object} progressProperty
			 * @property {string} value
			 * @property {string} duration
			 */
			/**
						 * @componentProperty {object} ltPropProgressProperty
						 * @version 1.0.0
						 * @default {"value":"0","duration" : "0s"}
						 */
			ltPropProgressProperty: Lyte.attr('object', { "default": { "value": "0", "duration": "0s" } }),

			/**
						 * @componentProperty {string} ltPropLabel
						 * @version 1.0.0
						 */
			ltPropLabel: Lyte.attr("string"),

			/**
						 * @componentProperty {string} ltPropFontSize
						 * @version 2.2.8
						 */
			ltPropFontSize: Lyte.attr("string"),

			/**
						 * @componentProperty {colorString} ltPropLabelColor
						 * @version 3.1.0
						 */
			ltPropLabelColor: Lyte.attr("string"),

			/**
						 * @experimental ltPropIndeterminate
						 */
			ltPropIndeterminate: Lyte.attr("boolean", { "default": false }),

			/**
						 * @componentProperty {array} ltPropStack
						 * @version 3.1.0
						 */
			ltPropStack: Lyte.attr("array", { "default": [] }),

			/**
						 * @componentProperty {up|down} ltPropDirection
						 * @version 3.1.0
						 * @default up
						 */
			ltPropDirection: Lyte.attr("string", { "default": "up" }),		//up,down

			/**
						 * @componentProperty {boolean} ltPropPercentage
						 * @version 3.1.0
						 * @default true
						 * 
						 */
			ltPropPercentage: Lyte.attr("boolean", { "default": true }),
			ltPropLineSeparator : Lyte.attr('boolean',{"default":false}),
			ltPropTooltip : Lyte.attr("boolean",{"default":false}),
			lyteUnbound : Lyte.attr("boolean", {"default" : false } ),
			ltPropAriaLabel: Lyte.attr("string",{"default":'loading'}),
			percentage: Lyte.attr('string', { "default": '0' }),
			duration: Lyte.attr('string', { "default": '2s' }),
			timingfn: Lyte.attr('string', { "default": 'linear' }),
			percentageDisplay: Lyte.attr('string', { "default": '0' }),
			checkIndeterminate: Lyte.attr("number", { "default": 0 }),
			chunks: Lyte.attr("array", { "default": [] }),
			prevValues: Lyte.attr("array", { "default": [] })
		}
	},
	init: function () {
		if (!(this.getData('ltPropWidth'))) {
			this.setData('ltPropWidth', this.getData('ltPropType') == "vertical" ? '20px' : '100%');
		}
		if (!(this.getData('ltPropHeight'))) {
			this.setData('ltPropHeight', this.getData('ltPropType') == "vertical" ? '200px' : '12px');
		}
	},
	didConnect: function () {
		// this.setData('ltPropValueCopy',this.getData('ltPropValue'));
		if (this.getData('ltPropIndeterminate')) {
			this.setData('checkIndeterminate', this.getData('checkIndeterminate') + 1);
		}
		else {
			if (this.getData('ltPropType') == "stacked") {
				this.stackId = [];
			}
			this.initial = $L.fastdom.mutate(this.setBackground.bind(this));
		}
		var _this = this;
		this.$node.value = function(value){
			_this.setData('ltPropProgressProperty.value',value);
		}


	},
	setChunks: function () {
		if (this.getData('ltPropType') != "stacked") {
			return;
		}
		var chunks = this.getData('chunks');
		var prop = this.getData('ltPropStack');
		var prevValues = this.getData('prevValues');
		if (chunks.length != prop.length) {
			chunks = [];
			for (var i = 0; i < prop.length; i++) {
				chunks.push(i);
			}
			this.setData('chunks', chunks);
			if (prevValues.length == 0) {
				for (var i = 0; i < prop.length; i++) {
					prevValues.push(0);
				}
			}
			else if (prevValues.length > prop.length) {
				prevValues.splice(prop.length);
			}
			else if (prevValues < prop.length) {
				for (var i = prevValues.length; i < prop.length; i++) {
					prevValues.push(0);
				}
			}
			this.setData('prevValues', prevValues);
		}
	}.observes('ltPropStack.[]').on('init'),
	observeIndeterminate: function () {
		if (this.getData('ltPropType') == "bar") {
			if (this.getData('ltPropIndeterminate') && this.getData('ltPropAnimated')) {
				this.setData('ltPropBackground', this.getData('ltPropProgressFillColor'));
				this.setData('duration', '0s');
				this.setData('percentage', '100');
			}
		}
	}.observes('ltPropIndeterminate', 'checkIndeterminate'),
	setProgressFillColor : function(){
		if($L('.lyteProgressStatus',this.$node)[0]){
			$L('.lyteProgressStatus',this.$node)[0].style.backgroundColor = this.getData('ltPropProgressFillColor');
		}else if($L('.ltProgressFillCircle',this.$node)[0]){
			$L('.ltProgressFillCircle',this.$node)[0].setAttribute('stroke',this.getData('ltPropProgressFillColor'));
		}else if($L('.lyteProgressStatusVertical',this.$node[0])){
			$L('.lyteProgressStatusVertical',this.$node)[0].style.backgroundColor = this.getData('ltPropProgressFillColor');
		}	
		this.data.ltPropBackground = this.getData('ltPropProgressFillColor');
	}.observes('ltPropProgressFillColor'),
	percentageChange: function (obj) {
		this.ChangePercentage();
	}.observes('ltPropProgressProperty', 'ltPropStack.[]', 'ltPropProgressProperty.value'),
	PerValue : function (value){
		var type = this.getData('ltPropType');
		var duration =  this.getData('duration');
		var timingfn =  this.getData('timingfn');
		var percentage = this.getData('percentage');
		var _this = this;
		switch(type){
			case 'circle':
				var radius = this.data.ltPropRadius;
				var stroke =this.data.ltPropStroke;
				var r = (radius)-(stroke)/2;
				var strokeDash =  2 * 3.14159 * r;
				var circle = this.$node.querySelector('.ltProgressFillCircle');
				circle.style.transition = 'stroke-dashoffset '+ duration + ' ' + timingfn;
				var per = strokeDash * (1 - (value)/100);
				setTimeout(function(){
					circle.setAttribute('stroke-dashoffset', per);
				},10);
				break;
			case 'stacked':
				var progressbars = $L('.lyteProgressStatusStack',_this.$node);
					var stack = this.getData('ltPropStack')
				var addWidth =  function(){
					for(var index = 0; index < stack.length ; index++){
						progressbars[index].style.width = stack[index].value + '%'; 
					}
				}	
				var progressbars = $L('.lyteProgressStatusStack',_this.$node);
				var stack = this.getData('ltPropStack')
				for(var index = 0; index < stack.length ; index++){
					var timingfn = stack[index].timingfn|| 'linear';
					var duration = stack[index].duration || '0s';
					progressbars[index].style.transition = 'width ' + duration + ' ' + timingfn ; 
				}
				setTimeout(function(){
					addWidth();
				},10);
				break;
			default:
				if(type == 'vertical'){
					var progressbar = $L('.lyteProgressStatusVertical',_this.$node)[0];
					progressbar.style.transition= 'height ' + duration + ' ' + timingfn;
					setTimeout(function(){
						progressbar.style.height = percentage + '%';
					},10);	
				}else{
					var progressbar = $L('.lyteProgressStatus',_this.$node)[0];
					progressbar.style.transition= 'width ' + duration + ' ' + timingfn;
					setTimeout(function(){
						progressbar.style.width = percentage + '%';
					},10);	
				}
				
				progressbar.style.transition= 'width ' + duration + ' ' + timingfn;
				break;		
		}
			
	},
	ChangePercentage : function(){
		if (this.getData('ltPropIndeterminate') || this.initial) {
			return;
		}
		this.setBackground();
	},
	setBackground: function () {
		var value = parseFloat(this.getData('ltPropProgressProperty').value);
		var duration = this.getData('ltPropProgressProperty').duration ? this.getData('ltPropProgressProperty').duration : this.getData('duration');
		if (this.getData('ltPropProgressProperty').timingfn) {
			this.setData('timingfn', this.getData('ltPropProgressProperty').timingfn);
		}
		if (this.getData('ltPropType') === 'circle') {
			if (parseInt(value) >= 100) {
				this.setData('duration', duration);
				this.setData('ltPropBackground', this.getData('ltPropProgressFillColor'));
				this.setData('percentage', '100');
				duration = parseFloat(duration) * 1000;
				var self = this;
				if (this.sid) {
					window.clearTimeout(this.sid);
					this.sid = false;
				}
				this.sid = setTimeout(function () {
					self.sid = false;
					if (!self.$node) {
						clearTimeout(self.sid);
						return;
					}
					self.$node.querySelector('.lyteProgressBar').classList.add('lyteProgressCompleted');
					self.setData('ltPropBackground', self.getData('ltPropCompletedFillColor'));
				}, duration);
			}
			else {
				if (this.sid) {
					clearTimeout(this.sid);
					this.sid = false;
				}
				this.$node.querySelector('.lyteProgressBar').classList.remove('lyteProgressCompleted');
				this.setData('ltPropBackground', this.getData('ltPropProgressFillColor'));
				this.setData('duration', duration);
				this.setData('percentage', value + "");
			}


		}
		else if (this.getData('ltPropType') === 'stacked') {
			// this.setChunks();
			var stacks = this.getData('ltPropStack');
			var bars = this.$node.querySelectorAll('.lyteProgressStatusStack');
			var prevValues = this.getData('prevValues');
			var left = 0;
			this.setData('duration', duration);
			for (var i = 0; i < stacks.length; i++) {
				value = parseFloat(stacks[i].value);
				// bars[i].style.width = value + "%";
				if (stacks[i].animated) {
					var animatedSpan = bars[i].querySelector('.ltPropProgressAnimated');
					animatedSpan.classList.add('progressMovingObj');
					animatedSpan.style.transition = 'left ' + duration + ' linear, width ' + duration + ' linear';
					animatedSpan.style.left = left + '%';
					animatedSpan.style.width = value + '%';
				}
				left += value;
				if (stacks[i].label) {
					bars[i].querySelector('.lyteProgressPercentageStack').innerHTML = stacks[i].label;
				}
				else {
					dur = parseFloat(stacks[i].duration || duration);
					if(!this.stackId){
						this.stackId = [];
					}
					if(this.stackId[i]) {
						clearInterval(this.stackId[i]);
						this.stackId[i] = false;
					}
					var p = prevValues[i] || 0,
						self = this,
						curr = { ind: i, value: value, ele: bars[i].querySelector('.lyteProgressPercentageStack'), p: p, stack: stacks[i] };
					if (dur == 0) {
						prevValues[i] = value;
						if (this.getData('ltPropShowPercentage')) {
							curr.ele.textContent = value + (this.getData('ltPropPercentage') ? "%" : "");
						}
					}
					else if (p > value) {
						var diff = p - value;
						curr.margin = ((diff / (dur * 1000)) * 100);
						this.stackId[i] = setInterval(this.changePercentageDisplay, 100, "dec", curr, this);
					}
					else if (p < value) {
						var diff = value - p;
						curr.margin = ((diff / (dur * 1000)) * 100);
						this.stackId[i] = setInterval(this.changePercentageDisplay, 100, "inc", curr, this);
					}
				}
			}
			this.PerValue(this.data.ltPropProgressProperty.value);
			return;
		}
		else if (this.getData('ltPropType') === 'vertical') {
			if (parseInt(value) >= 100) {
				this.setData('duration', duration);
				this.setData('ltPropBackground', this.getData('ltPropProgressFillColor'));
				this.setData('percentage', '100');
				// this.$node.querySelector('.lyteProgressStatus').style.width = "100%";
				duration = parseFloat(duration) * 1000;
				var self = this;
				if (this.sid) {
					window.clearTimeout(this.sid);
					this.sid = false;
				}
				this.sid = setTimeout(function () {
					self.sid = false;
					self.$node.querySelector('.lyteProgressBar').classList.add('lyteProgressCompleted');
					self.setData('ltPropBackground', self.getData('ltPropCompletedFillColor'));
					// if(self.getData('ltPropAnimated')){
					// 	self.$node.querySelector('.lyteProgressBar .ltPropProgressAnimated').classList.remove('progressMovingObj');	
					// }
				}, duration);
			}
			else {
				if (this.sid) {
					clearTimeout(this.sid);
					this.sid = false;
				}
				this.$node.querySelector('.lyteProgressBar').classList.remove('lyteProgressCompleted');
				this.setData('ltPropBackground', this.getData('ltPropProgressFillColor'));
				// if(this.getData('ltPropAnimated')){
				// 	this.$node.querySelector('.lyteProgressBar .ltPropProgressAnimated').classList.add('progressMovingObj');	
				// }
				this.setData('duration', duration);
				this.setData('percentage', value + "");

				// this.$node.querySelector('.lyteProgressStatus').style.width = value + "%";
			}
		}
		else {
			if (parseInt(value) >= 100) {
				this.setData('duration', duration);
				this.setData('ltPropBackground', this.getData('ltPropProgressFillColor'));
				this.setData('percentage', '100');
				// this.$node.querySelector('.lyteProgressStatus').style.width = "100%";
				duration = parseFloat(duration) * 1000;
				var self = this;
				if (this.sid) {
					window.clearTimeout(this.sid);
					this.sid = false;
				}
				this.sid = setTimeout(function () {
					self.sid = false;
					self.$node.querySelector('.lyteProgressBar').classList.add('lyteProgressCompleted');
					self.setData('ltPropBackground', self.getData('ltPropCompletedFillColor'));
					if (self.getData('ltPropAnimated')) {
						self.$node.querySelector('.lyteProgressBar .ltPropProgressAnimated').classList.remove('progressMovingObj');
					}
				}, duration);
			}
			else {
				if (this.sid) {
					clearTimeout(this.sid);
					this.sid = false;
				}
				this.$node.querySelector('.lyteProgressBar').classList.remove('lyteProgressCompleted');
				this.setData('ltPropBackground', this.getData('ltPropProgressFillColor'));
				if (this.getData('ltPropAnimated')) {
					this.$node.querySelector('.lyteProgressBar .ltPropProgressAnimated').classList.add('progressMovingObj');
				}
				this.setData('duration', duration);
				this.setData('percentage', value + "");

				// this.$node.querySelector('.lyteProgressStatus').style.width = value + "%";
			}
		}
		if (this.iId) {
			clearInterval(this.iId);
			this.iId = false;
		}
		var p = parseFloat(this.getData('percentageDisplay')),
			self = this;
		if (parseInt(this.getData('duration')) == 0) {
			this.setData('percentageDisplay', value + "");
		}
		else if (p > value) {
			var diff = p - value;
			var margin = ((diff / (parseInt(this.getData('duration')) * 1000)) * 100);
			this.iId = setInterval(function () {
				p -= margin;
				if (!self.$node) {
					clearInterval(self.iId);
					self.iId = false;
					return;
				}
				self.setData('percentageDisplay', Math.max(parseFloat(p.toFixed(2)), value) + "");
				if (parseFloat(p) == value) {
					clearInterval(self.iId);
					self.iId = false;
				}
			}, 100)
		}
		else if (p < value) {
			var diff = value - p;
			var margin = ((diff / (parseInt(this.getData('duration')) * 1000)) * 100);
			this.iId = setInterval(function () {
				p += margin;
				if (!self.$node) {
					clearInterval(self.iId);
					self.iId = false;
					return;
				}
				self.setData('percentageDisplay', Math.min(parseFloat(p.toFixed(2)), value) + "");
				if (parseFloat(p) >= value) {
					clearInterval(self.iId);
					self.iId = false;
				}
			}, 100)
		}
		this.PerValue(this.data.ltPropProgressProperty.value);
		delete this.initial;
	},
	changePercentageDisplay: function (cond, chunk, comp) {
		
		if (cond == "inc") {
			chunk.p += chunk.margin;
		}
		else {
			chunk.p -= chunk.margin
		}
		if (!comp.$node) {
			clearInterval(comp.stackId[chunk.ind]);
			comp.stackId[chunk.ind] = false;
			return;
		}
		var pd = cond == "inc" ? Math.min(parseFloat(chunk.p.toFixed(2)), chunk.value) : Math.max(parseFloat(chunk.p.toFixed(2)), chunk.value);
		if (comp.getData('ltPropShowPercentage')) {
			chunk.ele.textContent = pd + (comp.getData('ltPropPercentage') ? "%" : "");
		}
		if ((cond == "inc" && parseFloat(pd) >= chunk.value) || (cond == "dec" && parseFloat(pd) == chunk.value)) {
			clearInterval(comp.stackId[chunk.ind]);
			Lyte.arrayUtils(comp.getData('prevValues'), 'replaceAt', chunk.ind, chunk.value);
			comp.stackId[chunk.ind] = false;
		}
	},
	setCircleStroke: function (circle, val) {
		var per = circle.getAttribute('stroke-dasharray') * (1 - parseInt(val) / 100);
		circle.setAttribute('stroke-dashoffset', per);
	},
	didDestroy: function () {
		if (this.sid) {
			window.clearTimeout(this.sid);
			this.sid = false;
		}
		if (this.iId) {
			window.clearInterval(this.iId);
			this.iId = false;
		}
		if (this.stackId) {
			this.stackId.forEach(function (item, index) {
				if (item) {
					window.clearTimeout(this.sid);
					item = false;
				}
			});
		}
	}
});
Lyte.Component.registerHelper('lyteUiProgressBarLineSeparator',function(lineSeparator,index){ 
	return lineSeparator && index;
})
/**
 * @syntax nonYielded 
 * @attribute ltPropType=circle
 * <lyte-progressbar lt-prop = '{"type":"circle","progressProperty" : {"value" : "20", "duration" : "2s"}}'>
 * </lyte-progressbar>
 */

/**
* @syntax nonYielded 
* @attribute ltPropType=bar
* <lyte-progressbar lt-prop = '{"progressProperty" : {"value": "25.89", "duration" : "2s"}}'>
* </lyte-progressbar>
*/